module.exports = __webpack_public_path__ + "img/book2-active.caf370e3.png";